import React, { useContext } from "react";
import { PreviewContext } from '../_ModalsForms/ServiceRequestSetup'
import { Col, Form, FormGroup } from 'reactstrap'
import TextColorSelector from '../RequestServiceComponents/TextColorSelector';
import { useSelector } from 'react-redux'

function Preview() {

    const { bgColor, companyName, file } = useContext(PreviewContext);
    const labelDetails = useSelector(
        state =>
            state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    )
    
    var txtColor = TextColorSelector(bgColor);
    txtColor = txtColor === undefined || txtColor === null ? 'white' : txtColor;

    return (

        <div style={{ "maxWidth": "250px" }}>

            {/* LeftSidePane */}
            <div >
                <span style={{ fontSize: '12px', fontFamily: 'Arial', height: '26px', display: 'inline-block' }}
                    className='ServiceRequest_Header_lbl'>
                    {labelDetails['WorkOrderServiceRequestSetup.Preview.Text']}
                </span>

               
                <table style={{ "height": "100%", "width": "100%" }}>
                    <tr style={{ "height": "100%", "width": "00%" }}>
                        <td style={{ "backgroundColor": bgColor, "width": "40%", paddingBottom: '270px' }} >

                            <Form style={{ width: '141px' }}>
                                <FormGroup style={{ paddingTop: '18%' }}>
                                    <Col sm={{ size: 11 }} style={{"text-align":"center"}}>
                                        {(file === null || file === undefined) ?
                                            (<label className="ServiceRequest_Header_lbl" style={{ marginLeft: '-4px', fontWeight: 'bold', fontSize: '13px', width: '130px', fontFamily: 'Arial', height: '20px', color: txtColor }}>YOUR LOGO HERE</label>)
                                            : (<img style={{ "max-height": "120px",
                                            "min-height": "44px", "max-width": "110px", "min-width": "44px" }} src={file ? URL.createObjectURL(file) : null} alt={file ? file.name : null} />)}
                                    </Col>
                                </FormGroup>
                                <FormGroup >
                                    <Col sm={{ size: 0 }}>
                                        <label className={"ServiceRequest_Header_lbl"} style={{ fontWeight: 'bold', width: '130px', fontSize: '10px', fontFamily: 'Arial', color: txtColor, textAlign: 'center', wordWrap: 'break-word' }}>{companyName === null || companyName === undefined || companyName === '' ?
                                            'Company Name' : companyName}</label>
                                        <br />
                                    </Col>
                                </FormGroup>
                            </Form>
                        </td>

                        <td style={{ "backgroundColor": '#f5f6fa', "width": "60%" }}>
                            <table style={{ textAlign: 'center', marginTop: '6%' }}>
                                <tr>
                                    <label className="ServiceRequest_Header_lbl" style={{ paddingTop: '1%', fontSize: '12px', paddingRight: '31%', fontFamily: 'Arial', height: '20px' }}> {labelDetails['WorkOrderServiceRequestSetup.RequestService.Text']}</label>
                                </tr>
                                <tr>
                                    <label className={"ServiceRequest_Content_lbl"} style={{ fontSize: '8px', fontFamily: 'Arial', width: '120px', textAlign: 'left' }}>{labelDetails['WorkOrderServiceRequestSetup.FirstName.Text']}</label>
                                    <label className={"ServiceRequest_Content_lbl"} style={{ fontSize: '8px', fontFamily: 'Arial', width: '100px', textAlign: 'left' }}>{labelDetails['WorkOrderServiceRequestSetup.LastName.Text']}</label>
                                </tr>
                                <tr>
                                    <input type="text" class="ServiceRequest_Content_txtbox" disabled={true} style={{ "width": "100px", height: '18px' }} />
                                    <span style={{ width: '20px', display: 'inline-block' }} />
                                    <input type="text" class="ServiceRequest_Content_txtbox" disabled={true} style={{ "width": "100px", height: '18px' }} />
                                </tr>
                                <tr>
                                    <label className={"ServiceRequest_Content_lbl"} style={{ fontSize: '8px', fontFamily: 'Arial', width: '120px', textAlign: 'left' }}>{labelDetails['WorkOrderServiceRequestSetup.EmailAddress.Text']}</label>
                                    <label className={"ServiceRequest_Content_lbl"} style={{ fontSize: '8px', fontFamily: 'Arial', width: '100px', textAlign: 'left' }}>{labelDetails['WorkOrderServiceRequestSetup.PhoneNumber.Text']}</label>
                                </tr>
                                <tr>
                                    <input type="text" class="ServiceRequest_Content_txtbox" disabled={true} style={{ "width": "100px", height: '18px', marginLeft:'-8%' }} />
                                    <span style={{ width: '20px', display: 'inline-block' }} />
                                    <input type="text" class="ServiceRequest_Content_txtbox" disabled={true} style={{ "width": "70px", height: '18px' }} />
                                </tr>                               
                                <tr>
                                    <label className={"ServiceRequest_Content_lbl"} style={{ paddingRight: '43%', fontSize: '8px', fontFamily: 'Arial', textAlign: 'left' }}>{labelDetails['WorkOrderServiceRequestSetup.Description.Text']}</label>
                                    <br />
                                    <input type="text" class="ServiceRequest_Content_txtbox" disabled={true} style={{ "height": "55px", "width": "220px" }} />
                                </tr>
                                <tr>
                                    <div style={{ display: 'initial' }}>
                                        <label className="ServiceRequest_Content_lbl" style={{ paddingRight: '43%', fontSize: '8px', fontFamily: 'Arial' }}> {labelDetails['WorkOrderServiceRequestSetup.Attachments.Text']}</label>
                                        <br />
                                        <td style={{ border: '2px dashed #d8d8d8', height: '90px', width: '219px', backgroundColor: 'white' }}>
                                            <label style={{ textAlign: 'center', fontSize: '10px', fontFamily: 'Arial', marginLeft: '52px', fontWeight: 'bold' }}>Drop image here, or</label>
                                            <br />
                                            <label className="ServiceRequest_btn" style={{ "backgroundColor": 'white', border: '1px solid #85b0e4', color: '#85b0e4', fontSize: '9px', fontFamily: 'Arial', height: '20px', width: '67px', marginRight: '83px' }}>Choose File</label>
                                            <label style={{ textAlign: 'center', fontSize: '4px', fontFamily: 'Arial', marginLeft: '15px' }}>Attachments cannot be greater than 10MB. Acceptable formats: DOC, DOCX, JPG, JPEG, PNG or PDF"</label>
                                        </td>
                                    </div>
                                </tr>
                                <tr>
                                    <td style={{ paddingRight: '23%', paddingTop: '3%' }}>
                                        <label className="ServiceRequest_btn" style={{ paddingTop: '1%',"backgroundColor": bgColor, fontSize: '8px', fontFamily: 'Arial', height: '20px', width: '60px', color: txtColor }}>{labelDetails['WorkOrderServiceRequestSetup.Submit.Text']}</label>

                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ paddingRight: '23%', paddingTop: '3%' }}>
                                    </td>
                                </tr>
                            </table>


                        </td>
                    </tr>

                </table>


            </div>
        </div>


    )

}

export default Preview;